import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'

const dispatchService = {
  createDispatch: (params) => {
    const url = `${serverPath}${arsmoApi}/dispatch`
    return httpService.httpPost(url, params)
  },
}

export default dispatchService



// WEBPACK FOOTER //
// ./src/services/dispatch-service.js